import React from 'react';

import {Col, Row} from 'antd';


import {MoleskineType} from './Moleskine';
import Event from '../../model/Event';
import EventView from '../EventView/EventView';

import EmptyEvent from './EmptyEvent';
// import EventView from "../EventView/EventView";
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import {useTranslation} from "@nic-react-i18n/core";
import {useParams} from "react-router";
import {convertDate, FULL_DATE_CONF} from "../../utils";
import dayjs from "dayjs";

interface WeeklyViewProps extends MoleskineType {}

type WeeklyProps = WeeklyViewProps

const Today = styled.div`
    color: orange;
    font-weight: 800;
    text-transform: capitalize;
`;
const Simple = styled.div`
    text-transform: capitalize;
`;

const fillEventInTable = (event: Event, table: Record<string, Event[]>): void => {
    const {testDate} = event;
    const dateString: string = testDate.format('DD-MM-YYYY');

    if (!table[dateString]) {
        table[dateString] = [];
    }
    table[dateString].push(event);
};

const WeeklyView: React.FC<WeeklyProps> = (props)=> {
    const {t, locale} = useTranslation()
    const params = useParams()
    const constructOrarioSet = (props: WeeklyProps) => {

        //console.log('constuctOrarioSet: ', props)

        const {agenda} = props;
        let table = {};
        const events: Array<Event> = agenda.events;
        let orarioSet: Set<string> = new Set<string>();

        if (events) {
            events.forEach((event: Event) => {
                // console.log('Event ', event);
                orarioSet.add(event.testDate.format('HH:mm'));
            });
        }

        if (events) {
            events.forEach((event: Event) => {
                fillEventInTable(event, table);
            });
        }

        return orarioSet;
    }


    const constructTable = (props: WeeklyProps) => {
        //console.log('ContructTable: ', props)


        const {agenda} = props;
        let table = {};
        const events: Array<Event> = agenda.events;
        let orarioSet: Set<string> = new Set<string>();

        if (events) {
            events.forEach((event: Event) => {
                // console.log('Event ', event);
                orarioSet.add(event.testDate.format('HH:mm'));
            });
        }

        if (events) {
            events.forEach((event: Event) => {
                fillEventInTable(event, table);
            });
        }

        return table;
    }


   // console.log('WeeklyView: ', props)


    const [tableEvents, setTableEvents] = React.useState<any>(constructTable(props))
    const [orari, setOrari] = React.useState(constructOrarioSet(props))


    React.useEffect(() => {
        setTableEvents(constructTable(props))
        setOrari(constructOrarioSet(props))
    }, [props])



    const fillTableByTime = (orario: string, tableEvents: Record<string, Array<Event>>, day: dayjs.Dayjs,
                       dayIndex: number, tableByHours: Record<string, any>): void => {
        // let res = new Array(5);
        let dayString = day.format('DD-MM-YYYY');
        let events: Array<Event> = tableEvents[dayString];

        if (events) {
            // console.log('events: ', events, ' per data ', dayString);

            events.forEach((event: Event) => {
                if (event.testDate.format('HH:mm') === orario) {

                    if (!tableByHours[orario][dayIndex]) {
                        tableByHours[orario][dayIndex] = [];
                    }

                    tableByHours[orario][dayIndex].push(event);
                }
            });
        }
    }

    const renderDay = (day: dayjs.Dayjs, currentDate: dayjs.Dayjs): React.ReactElement<any> => {
        const  isToday: boolean =
            (dayjs(day.format('YYYY-MM-DD')).isSame(dayjs(currentDate.format('YYYY-MM-DD'))));

        //console.log('WeeklyView: ', day.toString(), currentDate.toString(), ' isToday: ', isToday)

        let formattedDay = convertDate(locale, day.toDate(), FULL_DATE_CONF)
        const comp = (isToday ? <Today>{formattedDay}</Today> : <Simple>{formattedDay}</Simple>);
        return (
            <span>
                {comp}
            </span>
        );
    }

    const renderEvents = (events: Array<Event>) => {
        let evts = Array<React.ReactNode>();
        // let relUrl;

        events.forEach((event: Event, i: number) => {

            evts.push(

                <EventView key={i} event={event} simple={true}/>
            );
        });

        return (
            <div>
                {evts}
            </div>
        );
    }

    const renderRowHeader = (firstDay: dayjs.Dayjs, weekday: number)  => {
        let fDay = dayjs(firstDay);
        let currentDate: dayjs.Dayjs = dayjs();


       // console.log('WeeklyView: renderRowDay: ', fDay.toString(), currentDate.toString(), ' weekday: ', weekday)

        let weekComponentHeader: Array<React.ReactElement<any>> = new Array<React.ReactElement<any>>();

        weekComponentHeader.push(
            <th key={0} style={{textAlign: 'center', borderBottom: '1px solid lightgray'}}>
                <span className={'weekly-header'}>{t('calendar.weekly.orari')}</span>
            </th>
        );

        for (let i = 0; i < weekday; i++) {
            //console.log('WeeklyView: fDay: ', fDay.toString())
            weekComponentHeader.push(
                <th
                    key={i + 1}
                    style={{textAlign: 'center', width: `${100 / (weekday + 1)}%`, borderBottom: '1px solid lightgray'}}
                >
                    {renderDay(fDay, currentDate)}
                </th>
            );
            fDay = fDay.add(1, 'day');
        }

        return weekComponentHeader;

    }

    const renderRowDay = (day: dayjs.Dayjs, events:  Array<Event>, orari: Array<string>) => {
        //console.log('renderRowDay: ', day, events, orari)


        let evts = Array<React.ReactNode>();

        if (events && events.length > 0) {

            orari.forEach((orario: string, i) => {
                let evv = Array<React.ReactNode>();

                if (events && events.length > 0) {
                    events.forEach((event: Event, e: number) => {
                        if (event.testDate.format('HH:mm') === orario) {
                            evv.push(
                                <EventView key={e} event={event} simple={true}/>
                            );
                        }
                    });
                }

                if (evv.length > 0) {
                    evts.push(
                        <Row key={i} style={{textAlign: 'center'}}>
                            <Col lg={4}>{orario}</Col>
                            <Col lg={20}>{evv}</Col>
                        </Row>
                    );
                }
            });
        } else {
            evts.push(
              <span key={9} style={{textAlign: 'center'}}>
                  <EmptyEvent showIcon={true} style={{color: 'lightgray'}}/>
              </span>
            );
        }

        let eventComp = (
            <Row>
                {evts}
            </Row>
        );

        return eventComp;
    }

    const renderByColumn = (firstDay: dayjs.Dayjs, weekday: number, year: number, month: number) => {

        let weekByRow: Array<React.ReactElement<any>> = new Array<React.ReactElement<any>>();
        let currentDate: dayjs.Dayjs = dayjs();
        const pari = 'trasparent';
        const dispari = '#fbfbfb    ';
        let sorted = Array.from(orari).sort();
        for (let i = 0; i < weekday; i++) {
            weekByRow.push(
                <Row
                    key={i}
                    style={{
                        padding: '10px',
                        borderTop: '1px dashed lightgray',
                        backgroundColor: `${i % 2 ? pari : dispari}`
                    }}
                >
                    <Col lg={4} >
                        {renderDay(firstDay, currentDate)}
                    </Col>
                    <Col lg={20}>
                        {renderRowDay(firstDay, tableEvents[firstDay.format('DD-MM-YYYY')], sorted)}
                    </Col>
                </Row>
            );
            firstDay = firstDay.add(1, 'day');

        }

        return weekByRow;
    }

    const renderByRow = (fDay: dayjs.Dayjs, weekday: number, year: number, month: number) => {
        // const {intl} = this.props;

        let sorted = Array.from(orari).sort();

        let tableByHours: Record<string, any> = {};

        sorted.forEach((hour: string): void => {
            tableByHours[hour] = new Array(5);
        });

        sorted.forEach((orario: string) => {

            let dDay = dayjs().year(year).isoWeekday(1).isoWeek(month);

            for (let i = 0; i < weekday; i++) {
                fillTableByTime(orario, tableEvents, dDay, i, tableByHours);
                dDay = dDay.add(1, 'day');
            }
        });

        let rr: Array<React.ReactElement<any>> = new Array<React.ReactElement<any>>();

        sorted.forEach((orario: string, i: number) => {
            let daysCols = [];
            for (let h = 0; h < weekday; h++) {
                daysCols.push(
                    <td
                        key={h}
                        style={
                            {textAlign: 'center',
                                borderBottom: '1px solid #f1f1f1',
                                backgroundColor: `${(h % 2) ?  'transparent' : '#f7f7f7' }`,
                                padding: '5px'
                            }
                        }
                    >
                        <div style={{height: '100%'}}>
                        {
                            tableByHours[orario][h] ?
                                renderEvents(tableByHours[orario][h]) :
                                <EmptyEvent style={{color: 'lightgray'}} />
                        }
                        </div>
                    </td>
                );
            }

            rr.push(
                <tr key={i}>
                    <td style={{textAlign: 'center', borderBottom: '1px solid #f1f1f1'}}>
                        <div style={{height: '100%'}}>
                            <span style={{height: '100%'}}>{orario}</span>
                        </div>
                    </td>
                    {daysCols}
                </tr>

            );
        });

        return rr;
    }

        const {agenda} = props;

        const weekday = 5;
    let currentDate: dayjs.Dayjs = dayjs();
        let year = params.year  ? +params.year : currentDate.year();
        let month =
            params.month ? +params.month : currentDate.isoWeek()


        let firstDay = dayjs().year(year).isoWeekday(1).isoWeek(month);

        let emptyValues = null;

        if (!agenda || !agenda.events || !agenda.events.length) {
            emptyValues = (
                <tr >
                    <td colSpan={weekday + 1} style={{textAlign: 'center', paddingTop: '30px'}}>

                            <EmptyEvent showIcon={true} style={{color: 'lightgray'}} />

                    </td>
                </tr>
            );

        }

        return (
            <span>
                <MediaQuery minWidth={1200}>
                    <div style={{marginTop: '30px'}}>
                        <table style={{width: '100%'}}>
                            <thead>

                            <tr>
                                {renderRowHeader(firstDay, weekday)}
                            </tr>
                            </thead>
                            <tbody>
                                {emptyValues}
                                {renderByRow(firstDay, weekday, year, month)}
                            </tbody>
                        </table>
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={1199}>
                    <div style={{marginTop: '30px'}}>
                        {emptyValues}
                        {renderByColumn(firstDay, weekday, year, month)}
                    </div>
              </MediaQuery>
            </span>
        );
}
export default WeeklyView